/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Certificate } from '../models';
/**
 * CertificateApi - axios parameter creator
 * @export
 */
export const CertificateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Certificate\"] 
         * @summary Get requested services
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCertificatesByServiceRequest: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getAllCertificatesByServiceRequest', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/certificate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CertificateApi - functional programming interface
 * @export
 */
export const CertificateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CertificateApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Certificate\"] 
         * @summary Get requested services
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Certificate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCertificatesByServiceRequest(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CertificateApi.getAllCertificatesByServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CertificateApi - factory interface
 * @export
 */
export const CertificateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CertificateApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readAll\", \"Certificate\"] 
         * @summary Get requested services
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Certificate>> {
            return localVarFp.getAllCertificatesByServiceRequest(serviceRequestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CertificateApi - interface
 * @export
 * @interface CertificateApi
 */
export interface CertificateApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"Certificate\"] 
     * @summary Get requested services
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApiInterface
     */
    getAllCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Certificate>>;

}

/**
 * CertificateApi - object-oriented interface
 * @export
 * @class CertificateApi
 * @extends {BaseAPI}
 */
export class CertificateApi extends BaseAPI implements CertificateApiInterface {
    /**
     *  **Permission required**: [\"readAll\", \"Certificate\"] 
     * @summary Get requested services
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CertificateApi
     */
    public getAllCertificatesByServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return CertificateApiFp(this.configuration).getAllCertificatesByServiceRequest(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }
}

